<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-button type="primary" icon="el-icon-lx-add" class="handle-add" @click="handlePowerEdit(true, null)">新增权限</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="权限名" align="center"></el-table-column>
                <el-table-column label="权限级别" align="center">
                    <template slot-scope="scope">
                        {{getPowerName(scope.row.p_id)}}
                    </template>
                </el-table-column>
                <el-table-column label="子权限" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            v-if="scope.row.sub_menu.length > 0"
                            @click="handleLookChildPower(scope.row)"
                        >查看子权限</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleChildPowerEdit(scope.row)"
                        >添加子权限</el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.sub_menu.length > 0"
                            @click="handleChildPowerFixed(scope.row)"
                        >修改子权限</el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.sub_menu.length > 0"
                            @click="handleChildPowerDel(scope.row)"
                        >删除子权限</el-button>
                        <el-button
                            type="text"
                            @click="handlePowerEdit(false, scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="powerEditVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="powerForm" :model="power_form" :rules="power_rules" label-width="120px">
                <el-form-item label="一级权限：" v-show="is_child">
                    <el-select v-model="window_power_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in windowPowerTypes"
                        :key="index"
                        :label="child.title" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="二级级权限：" v-show="is_child && windowPower2Types.length > 0">
                    <el-select v-model="window_power2_id" class="handle-select" @change="windowPower2Change">
                        <el-option
                        v-for="(child, index) in windowPower2Types"
                        :key="index"
                        :label="child.title" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="三级权限：" v-show="!is_child_add && is_child && windowPower3Types.length > 0">
                    <el-select v-model="window_power3_id" class="handle-select" @change="windowPower3Change">
                        <el-option
                        v-for="(child, index) in windowPower3Types"
                        :key="index"
                        :label="child.title" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限名：" prop="title">
                    <el-input v-model="power_form.title" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="路径：" prop="url">
                    <el-input v-model="power_form.url" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="路由名：" prop="path_name">
                    <el-input v-model="power_form.path_name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="菜单导航状态：" prop="type">
                    <el-select v-model="power_form.type" class="handle-select">
                        <el-option
                        v-for="(child, index) in showTtypes"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序序号：" prop="sort">
                    <el-select v-model="power_form.sort" class="handle-select">
                        <el-option
                        v-for="(child, index) in sorts"
                        :key="index"
                        :label="child" :value="child"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图标：" prop="icon">
                    <el-input v-model="power_form.icon" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="savePowerEdit('powerForm')">提 交</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="powerDelVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="delpowerForm" label-width="120px">
                <el-form-item label="一级权限：">
                    <el-select v-model="window_power_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in windowPowerTypes"
                        :key="index"
                        :label="child.title" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="二级级权限：" v-show="windowPower2Types.length > 0">
                    <el-select v-model="window_power2_id" class="handle-select" @change="windowPower2Change">
                        <el-option
                        v-for="(child, index) in windowPower2Types"
                        :key="index"
                        :label="child.title" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="三级权限：" v-show="windowPower3Types.length > 0">
                    <el-select v-model="window_power3_id" class="handle-select" @change="windowPower3Change">
                        <el-option
                        v-for="(child, index) in windowPower3Types"
                        :key="index"
                        :label="child.title" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="delChildPowerEdit">提 交</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="menuVisible" width="60%" :close-on-click-modal="false">
            <el-form>
                <el-tree
                :data="menus"
                node-key="id"
                ref="treeMenus"
                :default-expand-all="true"
                :props="defaultProps"
                ></el-tree>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="handlecloseChildPower">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {_} from 'vue-underscore';
import http from '../../../api/manageApiConfig'
//import http2 from '../../../api/iapetusApiConfig'
//import http3 from '../../../api/hermerApiConfig'
export default {
    name: 'Menumanage',
    data() {
        return {
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            page_index: 0,
            role_id: '',
            loading: false,
            is_add: false,
            is_child: false,
            is_child_add: false,
            is_post: false,
            powerTypes: ['一级权限', '二级权限', '三级权限'],
            windowPowerTypes:[],
            window_power_id: '',
            windowPower2Types:[],
            window_power2_id: '',
            windowPower3Types:[],
            window_power3_id: '',
            delete_menu_id: '',
            power_index: 0,
            powerEditVisible: false,
            powerDelVisible: false,
            showTtypes: [
                {'name': '显示', 'id': 1},
                {'name': '不显示', 'id': 2}
            ],
            sorts: [1,2,3,4,5,6,7,8,9,10],
            power_form: {},
            power_rules: {
                title: [{ required: true, message: "请填写权限名", trigger: "blur" }]
            },
            menus: [],
            menuVisible: false,
            defaultProps: {
                children: "sub_menu",
                label: "title",
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getPowerName(id){
            return this.powerTypes[id];
        },
        onInput(){
            this.$forceUpdate();
        },
        getData() {
            let that = this;
            that.loading = true;
            http.get("admin/menus").then(function(res) {
                that.tableData = res.data;
                that.loading = false;
            });
        },
        handleLookChildPower(row){
            this.menus = row.sub_menu;
            this.menuVisible = true;
        },
        handlecloseChildPower(){
            this.menuVisible = false;
        },
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    menu_id: row.id
                }
                http.delete("admin/menu", {params: params}).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }
                });
            })
            .catch(() => {});
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        },
        handlePowerEdit(add, row){
            this.is_add = add;
            this.is_child = false;
            this.is_child_add = false;
            this.is_post = add;
            if(add){
                this.power_form = {
                    p_id: 0,
                    title: '',
                    url: '',
                    path_name: '',
                    sort: 1,
                    type: 1,
                    icon: ''
                }
            }else{
                this.power_form = {
                    menu_id: row.id,
                    p_id: row.p_id,
                    title: row.title,
                    url:  row.url,
                    path_name:  row.path_name,
                    sort:  row.sort,
                    type:  row.type,
                    icon:  row.icon
                }
            }
            this.powerEditVisible = true;
        },
        savePowerEdit(formName){
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        p_id: that.power_form.p_id,
                        title: that.power_form.title,
                        url: that.power_form.url,
                        path_name: that.power_form.path_name,
                        sort: that.power_form.sort,
                        type: that.power_form.type,
                        icon: that.power_form.icon
                    }

                    if(!that.is_add || !that.is_child_add){
                        params['menu_id'] = that.power_form.menu_id;
                    }
                    if(that.is_child && that.is_child_add){
                        if(that.window_power_id){
                            params['p_id'] = that.window_power_id;
                        }
                        if(that.window_power2_id){
                            params['p_id'] = that.window_power2_id;
                        }
                        if(that.window_power3_id){
                            params['p_id'] = that.window_power3_id;
                        }
                    }

                    if(that.is_post){
                        http.post("admin/menu", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                            }
                        });
                    }else{
                        http.put("admin/menu", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                            }
                        });
                    }
                    that.powerEditVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleChildPowerEdit(row){
            let that = this;
            that.is_child = true;
            that.is_add = true;
            that.is_child_add = true;
            that.is_post = true;
            that.windowPowerTypes = [];
            that.windowPower2Types = [];
            that.windowPower3Types = [];
            that.windowPowerTypes.push(row);
            that.window_power_id = row.id;
            that.window_power2_id = '';
            that.window_power3_id = '';
            if(row.sub_menu.length > 0){
                that.windowPower2Types = [{'title': '无', 'id': ''}];
                that.windowPower2Types = that.windowPower2Types.concat(row.sub_menu);
            }
            that.power_form = {
                p_id: row.id,
                title: '',
                url: '',
                path_name: '',
                sort: 1,
                type: 1,
                icon: ''
            }
            that.powerEditVisible = true;
        },
        handleChildPowerFixed(row){
            let that = this;
            that.is_child = true;
            that.is_add = true;
            that.is_child_add = false;
            that.is_post = false;
            that.windowPowerTypes = [];
            that.windowPower2Types = [];
            that.windowPower3Types = [];
            that.windowPowerTypes.push(row);
            that.window_power_id = row.id;
            that.window_power2_id = '';
            that.window_power3_id = '';
            if(row.sub_menu.length > 0){
                that.windowPower2Types = [{'title': '无', 'id': ''}];
                that.windowPower2Types = that.windowPower2Types.concat(row.sub_menu);
            }
            that.power_form = {
                menu_id: row['id'],
                p_id: row['p_id'],
                title: row['title'],
                url: row['url'],
                path_name:  row['path_name'],
                sort: row['sort'],
                type: row['type'],
                icon: row['icon']
            }
            that.powerEditVisible = true;
        },
        windowPower2Change(){
            let that = this;
            if(!that.is_child_add){
                that.window_power3_id = '';
                that.windowPower3Types = [];
                let obj = {}
                if(that.window_power2_id){
                    http.get("admin/menu/"+that.window_power2_id).then(function(res) {
                        if (res.data.status_code == 200) {
                            if(res.data.data.length > 0){
                                that.windowPower3Types = [{'title': '无', 'id': ''}];
                                that.windowPower3Types = that.windowPower3Types.concat(res.data.data);
                            }
                        }
                    });
                    obj = _.filter(that.windowPower2Types, function(selector){ return selector.id == that.window_power2_id; })[0];
                }else{
                    obj = _.filter(that.windowPowerTypes, function(selector){ return selector.id == that.window_power_id; })[0];
                }
                that.power_form = {
                    menu_id: obj['id'],
                    p_id: obj['p_id'],
                    title: obj['title'],
                    url: obj['url'],
                    path_name:  obj['path_name'],
                    sort: obj['sort'],
                    type: obj['type'],
                    icon: obj['icon']
                }
                that.delete_menu_id = obj['id'];
            }
        },
        windowPower3Change(){
            let that = this;
            let obj = {}
            if(that.window_power3_id){
                obj = _.filter(that.windowPower3Types, function(selector){ return selector.id == that.window_power3_id; })[0];
            }else{
                obj = _.filter(that.windowPower2Types, function(selector){ return selector.id == that.window_power2_id; })[0];
            }
            that.power_form = {
                menu_id: obj['id'],
                p_id: obj['p_id'],
                title: obj['title'],
                url: obj['url'],
                path_name:  obj['path_name'],
                sort: obj['sort'],
                type: obj['type'],
                icon: obj['icon']
            }
            that.delete_menu_id = obj['id'];
        },
        handleChildPowerDel(row){
            let that = this;
            that.is_child_add = false;
            that.windowPowerTypes = [];
            that.windowPower2Types = [];
            that.windowPower3Types = [];
            that.windowPowerTypes.push(row);
            that.delete_menu_id = row.id;
            that.window_power_id = row.id;
            that.window_power2_id = '';
            that.window_power3_id = '';
            if(row.sub_menu.length > 0){
                that.windowPower2Types = [{'title': '无', 'id': ''}];
                that.windowPower2Types = that.windowPower2Types.concat(row.sub_menu);
            }
            that.powerDelVisible = true;
        },
        delChildPowerEdit(){
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    menu_id: that.delete_menu_id
                }
                http.delete("admin/menu", {params: params}).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                        that.powerDelVisible = false;
                    }
                });
            })
            .catch(() => {});
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
</style>
